import { useEffect, useState } from 'react'
import { FormatInput, TopicSelect } from 'src/components/common'
import { getLevelsRequest } from 'src/services/api.service'

export function FormItem({ index, topics, value, onChange, onDelete }) {
  const [topicId, setTopicId] = useState(value)
  const [levelId, setLevelId] = useState(null)
  const [levels, setLevels] = useState([])
  const [count, setCount] = useState(1)
  const [condition, setCondition] = useState(null)

  useEffect(() => {
    if (!topicId) return

    fetchLevels(topicId)
  }, [topicId])

  useEffect(() => {
    if (!levelId) {
      setCondition(null)
      return
    }

    const level = levels.find((x) => x.id === levelId)
    console.log('level.conditions', level.problem_types_params)

    setCondition(level.problem_types_params)
  }, [levelId])

  const fetchLevels = async (topic_id) => {
    const result = await getLevelsRequest({ topic_id, perPage: 1000 })
    setLevels(result.data.items || [])
  }

  const handleTopicChange = (item) => {
    setTopicId(item?.value)
    setLevelId(null)
  }

  const handleLevelChange = (item) => {
    setLevelId(item?.value)
  }

  const handleCountChange = (e) => {
    setCount(Number(e.target.value))
  }

  useEffect(() => {
    console.log('useEffect', [levelId, count, condition])

    if (!levelId) return

    onChange({ topic_id: topicId, level_id: levelId, count, condition })
  }, [topicId, levelId, count, condition])

  return (
    <div className="row">
      <div className="col-6 col-md-4 col-lg-4">
        <div className="input-block">
          <label>Topic</label>
          <TopicSelect
            placeholder="Topic"
            topics={topics}
            value={topicId}
            onChange={handleTopicChange}
            // disabled={!(formik.values.subject_id && formik.values.grade_id)}
          />
        </div>
      </div>

      <div className="col-6 col-md-4 col-lg-4">
        <div className="input-block">
          <label>Level</label>
          <TopicSelect
            placeholder="Level"
            topics={levels}
            value={levelId}
            onChange={handleLevelChange}
            disabled={!topicId}
          />
        </div>
      </div>

      <div className="col-6 col-md-3 col-lg-2">
        <div className="input-block">
          <label>Questions</label>
          <FormatInput
            type="number"
            name="count"
            onChange={handleCountChange}
            className="form-control"
            placeholder="5"
            required
            value={count}
            min={1}
          />
        </div>
      </div>

      {index !== 0 && (
        <div>
          <div style={{ marginTop: 22 }}>&nbsp;</div>
          <button onClick={onDelete} type="button">
            <img src="/account/images/dest/profile/close.svg" alt="close" />
          </button>
        </div>
      )}
    </div>
  )
}
